class Search {
	constructor(config) {
		this.config = Object.assign({
			scope: '.header-bottom',
			toggle: '.search-toggle',
			search: '#search-form',
			result: '.ajax_search_results_wrapper',
			input: '.search-input',
		}, config);

		if($(this.config.search).length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope = $(this.config.scope);

		this.$scope.on('click', this.config.toggle, () => {
			this.$scope.find(this.config.search).fadeIn('fast');
			this.$scope.find(this.config.input).focus();
		})

		this.$scope.on('focusout', this.config.input, () => {
			this.$scope.find(this.config.search).fadeOut('fast');
		});

		$(this.config.input).on('focus', () => {
			$(this.config.result).fadeIn('fast');
		});

		$(this.config.input).on('focusout', () => {
			$(this.config.result).fadeOut('fast');
		});
	}
}

export default new Search;